// extracted by mini-css-extract-plugin
export default {"toggle":"styles_toggle__h-qyB","toggle_active":"styles_toggle_active__wjVVB","toggle_slider":"styles_toggle_slider__PMGrH","toggle_inactive":"styles_toggle_inactive__qCPII"};